import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { EmojiSuggestion } from './emoji-suggestion.interface';
import { EmojiService } from '@core/services/emoji.service';


@Component({
  selector: 'app-emoji-suggestion',
  templateUrl: './emoji-suggestion.component.html',
  styleUrls: ['./emoji-suggestion.component.scss'],
})
export class EmojiSuggestionComponent implements OnChanges {
  @Input() suggestions: EmojiSuggestion[] = [];
  @Input() selectedIndex = 0;
  @Input() isVisible = false;

  @Output() suggestionSelected = new EventEmitter<any>();
  @Output() suggestionHighlighted = new EventEmitter<number>();
  @Output() closed = new EventEmitter<void>();

  constructor(
    private emojiService: EmojiService,
    private elementRef: ElementRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isVisible']?.currentValue === true &&
      !changes['isVisible'].previousValue
    ) {
      this.logEmojiSuggestionOpened();
    }

    if (changes['selectedIndex'] && this.isVisible) {
      this.scrollSelectedIntoView();
    }
  }

  selectEmojiSuggestion(emoji: any): void {
    this.suggestionSelected.emit(emoji);
  }

  closeEmojiSuggestion(): void {
    this.closed.emit();
  }

  focusOn(index: number): void {
    this.suggestionHighlighted.emit(index);
  }

  private logEmojiSuggestionOpened(): void {
    this.emojiService.logEmojiSuggestionOpened();
  }

  private scrollSelectedIntoView(): void {
    setTimeout(() => {
      const element =
        this.elementRef.nativeElement.querySelectorAll('.emoji-item')[
          this.selectedIndex
        ];
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }
}
